import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Loader from '../../components/componentloader'
import Layoult from '../../layoult';
import Page404 from '../../pages/error/page404';
import Security from '../../services/seguridad';
import { IMenu } from '../../services/seguridad/model';

interface IRoute {
  path: string;
  component: JSX.Element;
}

const logedoutRoutes : IRoute[] = [
  { path: '/', component: <Loader path="sistema/home" /> },
  { path: '/login', component: <Loader path="sistema/login" /> },
  { path: '/recoverypass', component: <Loader path="sistema/recoverypass" /> },
  { path: '/logout', component: <Loader path="sistema/logout" /> },
  { path: '/borrar-cache', component: <Loader path="sistema/borrar-cache" /> },
];

interface IProps {
}

interface IState {
  securityToken?: string;
  routes: IRoute[];
}

class Index extends React.Component<IProps, IState> {

  render() {
    const routes = [...logedoutRoutes];
    const expandMenu = (m: IMenu, acumulated: IRoute[]) => {
      if (m.url) {
        acumulated.push({
          path: m.url,
          component: <Loader path={m.url.substr(1)} />
        });
      }
      if (m.menus) m.menus.filter(p => p.url !== '/').map(p => expandMenu(p, acumulated));
    }
    Security.GetMenu(true).map(p => expandMenu(p, routes));

    return (
      <BrowserRouter>
        <Layoult>
          <Switch>
            {routes.map(route => (
              <Route path={route.path} component={() => route.component} key={route.path} exact />
            ))}
            <Route component={Page404} />
          </Switch>
        </Layoult>
      </BrowserRouter>
    );
  }
}

export default Index;
